if (!customElements.get('ta-hope-details')) {
  class TaHopeDetails extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      if (!this.details) return;

      this.desktop = window.matchMedia('(min-width: 750px)');
      this.updateLayout = () => {
        this.details.open = this.desktop.matches;
      };
      this.updateLayout();
      this.classList.add('is-enhanced');
      this.desktop.addEventListener('change', this.updateLayout);
    }

    disconnectedCallback() {
      this.desktop?.removeEventListener('change', this.updateLayout);
    }
  }

  customElements.define('ta-hope-details', TaHopeDetails);
}

customElements.whenDefined('carousel-slider').then(() => {
  if (customElements.get('ta-hope-gallery')) return;

  class TaHopeGallery extends customElements.get('carousel-slider') {
    handleNavClick(event) {
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        super.handleNavClick(event);
        return;
      }

      if (!event.target.matches('.slider-nav__btn')) return;
      const forward = (event.target.name === 'next') !== this.rtl;
      this.slider.scrollTo({
        left: this.slider.scrollLeft + (forward ? 1 : -1) * this.slidesToScroll * this.slideSpan,
        behavior: 'auto'
      });
    }
  }

  customElements.define('ta-hope-gallery', TaHopeGallery);
});
